import { render, staticRenderFns } from "./AccountFortuneGroup.vue?vue&type=template&id=68078d08&scoped=true&"
import script from "./AccountFortuneGroup.vue?vue&type=script&lang=js&"
export * from "./AccountFortuneGroup.vue?vue&type=script&lang=js&"
import style0 from "./AccountFortuneGroup.vue?vue&type=style&index=0&id=68078d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68078d08",
  null
  
)

export default component.exports